import type { SmartCardClientResponse } from './SmartCardClient';

// TRELP-7493: Redact `urlType` because it is considered UGC when retrieved via
// iframely or public object resolver
export const getSafeUrlType = (response: SmartCardClientResponse) => {
  if (
    ['iframely-object-provider', 'public-object-provider'].includes(
      response.meta.key,
    )
  ) {
    return 'REDACTED';
  }
  if (
    response.data &&
    'generator' in response.data &&
    typeof response.data.generator === 'object'
  ) {
    return response.data.generator.name;
  }
  return undefined;
};
